import { css } from '@styled-system/css';
import styled from 'styled-components';
import { Search } from '@humaninterest/hi-react-dripicons';

import Container from 'humanity/primitives/container';
import Section from 'humanity/primitives/section';
import { lcMastheadProps } from 'humanity/sections/lcMasthead/lcMasthead.types.js';
import { HeadingWithHighlight } from 'humanity/components/headingWithHighlight';
import SimpleRichText from 'humanity/components/simpleRichText';
import Flex from 'humanity/primitives/flex';
import Image from 'humanity/primitives/image';
import Grid from 'humanity/primitives/grid';
import { SearchInput } from 'humanity/components/searchInput';

const StyledSection = styled(Section)((props) => css({ bg: props.background }));
const StyledContainer = styled(Container)(css({}));
const StyledCopy = styled(Flex)((props) =>
  css({
    gridColumn: props.isOneImage ? ['1 / 13', '1 / 8'] : ['1 / 13', '5 / 9'],
    alignItems: ['flex-start', null, null, props.isOneImage ? 'flex-start' : 'center'],
    flexDirection: 'column',
    justifyContent: 'center',
    my: 6,
  })
);
const StyledImageWrapper = styled(Flex)((props) =>
  css({
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'center',
    display: ['none', 'flex'],
    gridColumn: props.left ? [null, '1 / 5'] : [null, '9 / 13'],
  })
);
const LcMasthead = ({
  heading,
  headingHighlight,
  background,
  paragraph = null,
  searchInput = null,
  imagesCollection,
}) => {
  const items = imagesCollection?.items;
  const isOneImage = items?.length === 1;
  let leftImage;
  let rightImage;
  if (items?.length) {
    // If only one image, default to right image
    if (items.length > 1) {
      // eslint-disable-next-line prefer-destructuring
      leftImage = items[0];
      // eslint-disable-next-line prefer-destructuring
      rightImage = items[1];
    } else {
      leftImage = null;
      // eslint-disable-next-line prefer-destructuring
      rightImage = items[0];
    }
  }
  return (
    <StyledSection background={background}>
      <StyledContainer>
        <Grid>
          {leftImage && (
            <StyledImageWrapper left>
              <Image
                src={leftImage.image?.url}
                width={leftImage.width}
                height={leftImage.height}
                quality={100}
                imgixParams={{ auto: 'format' }}
                priority
              />
            </StyledImageWrapper>
          )}
          <StyledCopy isOneImage={isOneImage}>
            {isOneImage ? (
              <HeadingWithHighlight
                heading={heading}
                highlight={headingHighlight}
                textAlign={['left', null, null, isOneImage ? 'left' : 'center']}
                variant="h3"
              />
            ) : (
              <HeadingWithHighlight
                heading={heading}
                highlight={headingHighlight}
                textAlign={['left', null, null, isOneImage ? 'left' : 'center']}
                variant={['h4', null, 'h4', 'h2']}
              />
            )}{' '}
            {paragraph && (
              <SimpleRichText
                content={paragraph?.json}
                mt={2}
                mb={4}
                textAlign={['left', null, null, isOneImage ? 'left' : 'center']}
              />
            )}
            {searchInput && (
              <SearchInput
                placeholder={searchInput}
                width="auto"
                LeftIcon={Search}
                bg="white"
                minWidth="240px"
              />
            )}
          </StyledCopy>
          {rightImage && (
            <StyledImageWrapper right>
              <Image
                src={rightImage.image?.url}
                width={rightImage.width}
                height={rightImage.height}
                quality={100}
                imgixParams={{ auto: 'format' }}
                priority
              />
            </StyledImageWrapper>
          )}
        </Grid>
      </StyledContainer>
    </StyledSection>
  );
};

LcMasthead.propTypes = {
  ...lcMastheadProps,
};

export default LcMasthead;
